import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

const NoAccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const noRoleAssigned = searchParams.get('noRoleAssigned') === 'true';

  return (
    <div className="flex flex-col items-center justify-center bg-white h-[calc(100vh-70px)]">
      <h1 className="text-2xl font-bold">No Access</h1>
      {!noRoleAssigned && <p className="text-gray-500">You do not have permission to access this page. Please contact your administrator.</p>}
      {noRoleAssigned && <p className="text-gray-500">No Access Assigned. Please contact your admin team for role assignment.</p>}
      {!noRoleAssigned && <Button variant="primary" onClick={() => navigate("/home")}>Go to Home</Button>}
    </div>
  );
};

export default NoAccess;